// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__t0RsI","icon":"styles_icon__29BAx"};